import React from 'react'

import { Button, Icon } from '../../../../module'
import styles from './_table-filter-pill.module.scss'

type TableFilterPillProps = {
  text: string
  remove: () => void
}

const TableFilterPill = ({
  text,
  remove,
}: TableFilterPillProps): React.JSX.Element => {
  return (
    <div className={styles.container}>
      <span className={styles.text}>{text}</span>
      <Button as='unstyled' onClick={remove}>
        <Icon icon='x' iconSize='8px' className={styles.pillIcon} />
      </Button>
    </div>
  )
}

export default TableFilterPill
